import React from "react";
import { withStyles } from "@mui/styles";

import Table from "../../components/table/Table";

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

const headings = [
  {
    label: "First name",
    key: "firstName",
  },
  {
    label: "Last name",
    key: "lastName",
  },
  {
    label: "Team",
    key: "team",
  },
  {
    label: "Event",
    key: "event",
  },
  {
    label: "Event date",
    key: "eventDate",
    type: "date",
  },
  {
    label: "Type",
    key: "type",
  },
  {
    label: "Fee",
    key: "fee",
    type: "currency",
  },
  {
    label: "Adjusted Fee",
    key: "adjustedFee",
  },
  {
    label: "Status",
    key: "status",
  },
  {
    label: "Date Paid",
    key: "paidAt",
    type: "date",
  },
  {
    label: "Id",
    key: "id",
  },
  {
    label: "Charge Date",
    key: "chargeDate",
  },
  {
    label: "GoCardless Id",
    key: "gocardlessId",
  },
  {
    label: "GoCardless Status",
    key: "gocardlessStatus",
  },
];

function ClubReportTable({
  classes,
  detailedReportData,
  addButtonText,
  onAddButtonClick,
  hideSearch,
  onEditFeeCategory,
  onDeleteFeeCategory,
  additionalButtons,
  showDateRangeFilter,
  dateRangeFilterStart,
  onDateRangeFilterStartChange,
  dateRangeFilterEnd,
  onDateRangeFilterEndChange,
  filterSelects,
  showDownloadButton,
  downloadFilename,
}) {
  return (
    <div className={classes.section}>
      <Table
        hideSearch={hideSearch}
        addButtonText={addButtonText}
        headings={headings}
        data={detailedReportData}
        onAddButtonClick={
          onAddButtonClick ? (payload) => onAddButtonClick(payload) : null
        }
        rowActions={[
          {
            type: "edit",
            onClick: onEditFeeCategory
              ? (member) => onEditFeeCategory(member)
              : null,
          },
          {
            type: "delete",
            onClick: onDeleteFeeCategory
              ? (member) => onDeleteFeeCategory(member)
              : null,
          },
        ]}
        additionalButtons={additionalButtons}
        showDateRangeFilter={showDateRangeFilter}
        dateRangeFilterStart={dateRangeFilterStart}
        onDateRangeFilterStartChange={(value) =>
          onDateRangeFilterStartChange(value)
        }
        dateRangeFilterEnd={dateRangeFilterEnd}
        onDateRangeFilterEndChange={(value) =>
          onDateRangeFilterEndChange(value)
        }
        filterSelects={filterSelects}
        showDownloadButton={showDownloadButton}
        downloadFilename={downloadFilename}
      />
    </div>
  );
}

export default withStyles(styles)(ClubReportTable);
